import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const GenerateWeblink = lazy(() => import('components/l3System/downloadWeblink/GenerateWeblink'));
const GenerateWeblinkPage = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<GenerateWeblink />
			</Suspense>
		</div>
	);
};
export default GenerateWeblinkPage;
